import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgModelBaseComponent } from './ng-model-base.component';

@Component({
  selector: 'toggle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true
    }
  ],
})
export class ToggleComponent extends NgModelBaseComponent implements AfterViewInit {
  @Input() checked: Boolean = false;
  @Input() invalid: Boolean = false;
  @Input() classTam: string = '';
  @Input() lbTrue: string = 'Yes';
  @Input() lbFalse: string = 'No';
  @Input() disable: boolean = false;
  @Output() toggled: EventEmitter<Boolean>;

  constructor() {
    super();
    this.toggled = new EventEmitter<Boolean>();
    // this.value = this.checked ? true : false
    // this.toggled.emit(this.value);
  }


  ngAfterViewInit(): void {
    // this.value = this.checked ? true : false
  }

  onClick() {
    if (!this.disable)
      this.value = !this.value;
    this.toggled.emit(this.value);
  }
}
